module.exports = __webpack_public_path__ + "static/img/consult.98fb4f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background/consult.jpg
// module id = +7o+
// module chunks = 1